module.exports = __webpack_public_path__ + "profile-bg.60ce94f06be4f882efdf.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/images/profile-bg.png
// module id = ../../../../../src/assets/layout/images/profile-bg.png
// module chunks = 2